const options = {
  truncate(value, limit) {
    if(!value) return;
    if(value.length > limit){
      return value.substring(0, limit)+' ...'
    }else{
      return value
    }
  },
  truncate_start(value, limit) {
    if(!value) return;
    if(value.length > limit){
      return '...'+value.substring(value.length, value.length - limit)
    }else{
      return value
    }
  },
  validFields(data) {
    return Object.fromEntries(
        Object.entries(data ?? {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')
    );
  },
  slug(value) {
    if (!value) return null
    return value.toString().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'-').toLowerCase().replace(/&/g,'-and-').replace(/[^a-z0-9\-]/g,'').replace(/-+/g,'-').replace(/^-*/,'').replace(/-*$/,'');
  },
  textFromSlug(value){
    if (!value) return '';
    let words = value.split('_');
    let formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    return formattedWords.join(' ');
  },
  capitalize (value) {
    if (!value) return ''
    value = value.toString()
    let arr = value.split(" ")
    let capitalized_array = []
    arr.forEach((word) => {
      let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
      capitalized_array.push(capitalized)
    })
    return capitalized_array.join(" ");
  },
  addSeparator(value, sep = '-') {
    if (!value) return ''
    return value.replace(/(.{4})/g, `$1${sep}`).slice(0, -(sep.length));
  },
  calculateAge(dobDate) {
    if (!dobDate) { return null; }
    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
        age--;
    }
    return age;
  },
  maskString(input, revealCount = 3) {
    if(!input) return;

    const str = input.toString();
    if (revealCount < 0 || revealCount > str.length) {
      return "*";
    }
    const masked = '*'.repeat(str.length - revealCount) + str.slice(-revealCount);
    return masked;
  },
  chunkArray(array, chunkSize) {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  },
  encodeURL(url) {
    if(!url) return '';
    const encodedUrl = btoa(unescape(encodeURIComponent(url)));
    return encodedUrl;
  },
  decodeURL(url) {
    if(!url) return '';
    const decodedUrl = decodeURIComponent(escape(atob(url)));
    return decodedUrl;
  },
  evaluateBMI(value){
    let list = [
      { from: 0, to: 18.5, title: 'Underweight', color: '#bc2020' },
      { from: 18.5, to: 25, title: 'Normal', color: '#008137' },
      { from: 25, to: 30, title: 'Overweight', color: '#ffe400' },
      { from: 30, to: Infinity, title: 'Obesity', color: '#bc2020' }
    ];
    for (let i = 0; i < list.length; i++) {
        if (value >= list[i].from && value < list[i].to) {
          let range = list[i];
          return `<span style="background:${range.color}24; color:${range.color}; padding:0px 5px 2px 5px;line-height:1; border-radius:4px;">${range.title}</span>`
        }
    }
    return '';
  },
  time(value, is24HrFormat = false) {
    if(value) {
      const date = new Date(Date.parse(value));
      let hours = date.getHours();
      const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
      if(!is24HrFormat) {
        const time = hours > 12 ? 'AM' : 'PM';
        hours = hours % 12 || 12;
        return hours + ':' + min + ' ' + time
      }
      return hours + ':' + min
    }
  },
  calculateDeliveryTime(time){
    if(!time){return '0 day'}
    return (time > 24) ? Math.round(time/24) + ' days' : '1 day'
  },
  getPercent(val, total){
    return Math.round((parseFloat(val) * 100) / parseFloat(total)) || 0
  },
  numberToAlpha(num) {
    let alpha = "";
    while (num > 0) {
        let rem = (num - 1) % 26;
        alpha = String.fromCharCode(65 + rem) + alpha; // 65 = 'A'
        num = Math.floor((num - 1) / 26);
    }
    return alpha;
  },
  formatDuration(days) {
    days = parseInt(days, 10);
    if(!days) { return "" }
    const ONE_YEAR = 365;
    const ONE_MONTH = 30;
    const ONE_WEEK = 7;

    let years = Math.floor(days / ONE_YEAR);
    days %= ONE_YEAR;

    let months = Math.floor(days / ONE_MONTH);
    days %= ONE_MONTH;

    let weeks = Math.floor(days / ONE_WEEK);
    days %= ONE_WEEK;

    let result = [];

    if (years > 0) {
        result.push(`${years} year${years > 1 ? 's' : ''}`);
    }
    if (months > 0) {
        result.push(`${months} month${months > 1 ? 's' : ''}`);
    }
    if (weeks > 0) {
        result.push(`${weeks} week${weeks > 1 ? 's' : ''}`);
    }
    if (days > 0) {
        result.push(`${days} day${days > 1 ? 's' : ''}`);
    }
    return result.length > 0 ? result.join(", ") : "0 days";
  },
  formatDurationInMinutes(minutes) {
    minutes = parseInt(minutes, 10);
    if (!minutes) return "";

    const ONE_DAY = 24 * 60;
    const ONE_HOUR = 60;

    let days = Math.floor(minutes / ONE_DAY);
    minutes %= ONE_DAY;

    let hours = Math.floor(minutes / ONE_HOUR);
    minutes %= ONE_HOUR;

    let result = [];

    if (days > 0) {
        result.push(`${days} day${days > 1 ? "s" : ""}`);
    }
    if (hours > 0) {
        result.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    }
    if (minutes > 0) {
        result.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
    }
    return result.length > 0 ? result.join(" ") : "0 minute";
 },
  date(value, index = 0) {
    if(!value) return;
    var options = [
      { year:'numeric', month:'short', day:'2-digit' },
      { year:'2-digit', month:'short', day:'2-digit', hour: '2-digit', minute:'2-digit' },
      { year:'numeric', month:'short', day:'2-digit', hour: '2-digit', minute:'2-digit' },
      { weekday:'long', year:'numeric', month:'short', day:'2-digit', hour: '2-digit', minute:'2-digit' },
    ];
    var givenDate  = new Date(value);
    return new Intl.DateTimeFormat('en-US', options[index]).format(givenDate)
  },
  isFuture(dateTime) {
    if (!dateTime) return false;

    const date = new Date(dateTime);
    if (isNaN(date.getTime())) return false; // invalid date check

    return date > new Date();
  },
  isPast(dateTime) {
    if (!dateTime) return false;

    const date = new Date(dateTime);
    if (isNaN(date.getTime())) return false;

    return date < new Date();
  },
  isSecondDateGreater(firstDate, secondDate) {
    const date1 = new Date(firstDate);
    const date2 = new Date(secondDate);
    return date2 > date1;
  },
  formatSchedulePeriod(start_at, end_at) {

    const startDate = new Date(start_at);
    const endDate = new Date(end_at);
  
    const dateTimeOptions = { month: 'long', day: 'numeric', 
      year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
    
    const timeOptions = { hour: 'numeric',  minute: 'numeric',  hour12: true};
  
    const formattedStart = startDate.toLocaleString('en-US', dateTimeOptions);
  
    const isSameDay = startDate.toDateString() === endDate.toDateString();
  
    const formattedEnd = isSameDay 
      ? endDate.toLocaleString('en-US', timeOptions) 
      : endDate.toLocaleString('en-US', dateTimeOptions);
  
    return `${formattedStart} to ${formattedEnd}`;
  },
  month_year(value) {
    var options = {month: 'short', year: 'numeric'};
    var givenDate  = new Date(value);
    if(!value || givenDate == 'Invalid Date'){return;}
    return givenDate.toLocaleString("en-US", options);
  },
  month(val, showYear = true) {
    val = String(val)
    const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
    if(!showYear) {
      return regx.exec(val)[1];
    }else {
      return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
    }
  },
  csv(value) {
    return value.join(', ')
  },
  filter_tags(value) {
    return value.replace(/<\/?[^>]+(>|$)/g, "")
  },
  k_formatter(num) {
    num = parseFloat(num);
    if(!num){ return '' }
    return num > 999 ? (num/1000).toFixed(1) + 'k' : num
  },
  formatAlphanumeric(value) {
    if(!value) return "";
    const item = value.replace(/[^a-zA-Z0-9]/g, '');
    return item;
  },
  money_format(number, decimal = 2) {
    let i = parseFloat(number); if(isNaN(i)) {return;}
    return i.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  },
  number_format(number, decimal = 0) {
    let i = parseFloat(number); if(isNaN(i)) {return;}
    return i.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  },
  deliveryDate(startDate, hrs){
    if(!startDate || !hrs) return;
    let option = { year:'2-digit', month:'short', day:'2-digit'}
    var givenDate  = new Date().setTime(new Date(startDate).getTime() + (parseInt(hrs)*60*60*1000));
    return new Intl.DateTimeFormat('en-US', option).format(givenDate)
  },
  convertBytesToMB(bytes) {
    if(!bytes) return 0;
    const bytesPerMB = 1024 * 1024;
    return Math.round(bytes / bytesPerMB);
  },
  getFileExtension(name) {
    if(!name) return "";
    const fileName = name;
    const extension = fileName.split('.').pop();
    return extension.toLowerCase();
  },
  getReadableFileSize(size) {
    if(!size) return "";
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB'];
    let index = 0;
    let readableSize = size;
    while (readableSize >= 1024 && index < units.length - 1) {
        readableSize /= 1024;
        index++;
    }
    return `${readableSize.toFixed(2)} ${units[index]}`;
  },
  isBase64(string) {
    const base64Regex = /^data:image\/[a-zA-Z]+;base64,/;
    return base64Regex.test(string);
  },
  isUrl(string) {
    try {
        const url = new URL(string);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (_) {
        return false;
    }
  },
  updateURL(newURL) {
    if (history.pushState) {
      history.pushState(null, null, newURL);
    } else {
      window.location.href = newURL;
    }
  },
  fileReader(file) {
    return new Promise((resolve, reject) => {
      if (typeof FileReader !== 'function') {
        reject('Sorry, FileReader API not supported')
      }
      var reader = new FileReader();
      reader.onload = function(event) {
        var img = new Image();
        img.onload = function() {
          var height = img.naturalHeight;
          var width = img.naturalWidth;
          resolve({
            height: height,
            width: width,
            dataURL: event.target.result
          });
        };
        img.src = event.target.result;
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  },
  base64ToBlob(base64, mimeType) {
    const byteString = atob(base64.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  },
  uploadableFileData(file){
    if(!file){ return null }
    const data = {
      name: file.name,
      type: file.type,
      extension: this.getFileExtension(file.name),
      size: this.getReadableFileSize(file.size)
    }
    return data;
  },
  formatKeyValue(obj) {
    if(!obj) return '';
    return Object.entries(obj)
      .map(([key, value]) => `${key}:${value}`)
      .join('; ');
  },
  patchUpdatables(data, filter) {
    if(!filter){ return data }
    let allowed = Object.keys(data);
    const filteredData =  Object.keys(filter || {})
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        if(Array.isArray(data[key])){
          obj[key] = [...filter[key]]
        }else if(typeof data[key] === 'object' && data[key] !== null){
          obj[key] = {...filter[key]}
        }else{
          obj[key] = filter[key] === null ? "" : filter[key];
        }
        return obj;
      }, {});
    return JSON.parse(JSON.stringify(filteredData))
  },
  date_ago(utctime, index = 0) {
    const iptDate = new Date(utctime);
    const curDate = new Date();
    const timeD = curDate - iptDate;
    const millisecsPerSec = 1000;
    const millisecsPerMin = 60 * millisecsPerSec;
    const millisecsPerHr = 60 * millisecsPerMin;
    const millisecsPerDay = 24 * millisecsPerHr;

    if (timeD < millisecsPerDay) {
      const daysAgo = Math.floor(timeD / millisecsPerDay);
      const hrsAgo = Math.floor((timeD % millisecsPerDay) / millisecsPerHr);
      const minsAgo = Math.floor((timeD % millisecsPerHr) / millisecsPerMin);
      const secsAgo = Math.floor((timeD % millisecsPerMin) / millisecsPerSec);

      if (daysAgo > 0) {
        return `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
      } else if (hrsAgo > 0) {
        return `${hrsAgo} hr${hrsAgo > 1 ? 's' : ''} ago`;
      } else if (minsAgo > 0) {
        return `${minsAgo} min${minsAgo > 1 ? 's' : ''} ago`;
      } else if (secsAgo > 0) {
        return `${secsAgo} sec${secsAgo > 1 ? 's' : ''} ago`;
      } else {
        return "just now";
      }
    } else {
      const options = [
        { year:'2-digit', month:'short', day:'2-digit', hour: '2-digit', minute:'2-digit' },
        { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }
      ];
      return new Intl.DateTimeFormat('en-US', options[index]).format(iptDate)
    }
  },
   timeToString() {
        const now = new Date();
        const customDateTimeString = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
        return customDateTimeString;
    },
}

export default {
  install: (app) => {
    app.config.globalProperties.$filters = options
    // app.provide('$filters', options)
  }
}